function formatConflictDate(dateStr) {
  if (!dateStr) return dateStr;
  const [y, m, d] = dateStr.split('-').map(Number);
  if (!y || !m || !d) return dateStr;
  return `${y}. ${String(m).padStart(2, '0')}. ${String(d).padStart(2, '0')}.`;
}

export function formatEventConflictWarning(conflict) {
  const date = formatConflictDate(conflict.date);
  const time = conflict.time || '';
  const title = conflict.otherTitle || 'Ismeretlen esemény';
  return `Időpont-ütközés: ${date} ${time} – „${title}”`;
}

export function formatEventConflictWarnings(conflicts) {
  if (!Array.isArray(conflicts) || conflicts.length === 0) return '';
  const lines = conflicts.map(formatEventConflictWarning);
  if (lines.length === 1) return lines[0];
  return `${lines.length} időpont-ütközés:\n${lines.join('\n')}`;
}
